module.exports = __webpack_public_path__ + "img/tel.d5b60f8e.png";